import styled from 'styled-components';

interface InvestorOptionProps {
  bold?: boolean;
  uppercase?: boolean;
  small?: boolean;
}
interface OptionProps {
  color?: string;
}

export const InvestorIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;

export const InvestorOption = styled.div<InvestorOptionProps>`
  display: flex;
  align-items: center;

  padding: 0 1.375rem;
  background-color: ${({ theme }) => theme.colors.grey[0]};
  min-height: 3.75rem;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }

  p {
    font-family: ${({ theme }) => theme.fonts.secondary};
    line-height: 23px;
    letter-spacing: 1.2px;

    ${({ bold, theme }) => bold && `font-weight: ${theme.fonts.weight.bold};`}
    color: ${({ theme }) => theme.colors.black[900]};
  }
`;

export const Option = styled.div<OptionProps>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[0]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  min-height: 3.75rem;
  width: 60px;
  cursor: pointer;
`;

export const MenuContent = styled.div`
  height: calc(100% - 40px);
  &:hover {
    overflow: scroll;
  }
`;

export const MenuTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 1.375rem;
  background-color: ${({ theme }) => theme.colors.grey[0]};
  min-height: 3.875rem;
  width: 100%;

  h2 {
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-size: 0.8125em;
    line-height: 23px;
    letter-spacing: 1.2px;
    text-transform: uppercase;

    color: ${({ theme }) => theme.colors.black[900]};
  }
`;
